"use client";

import { useRouter } from "next/navigation";
import CardIssue from "public/card-issue.svg";
import KinsaListContentWidget from "src/components/KinsaListContentWidget";
import { Routes } from "src/lib/routes";
import { STATSIG_EVENTS } from "@repo/statsig";

interface PaymentProcessingIssueStateProps {
  className?: string;
  onManagePayment?: () => void;
}

const PaymentProcessingIssueState: React.FC<
  PaymentProcessingIssueStateProps
> = ({ className, onManagePayment }) => {
  const router = useRouter();
  return (
    <KinsaListContentWidget
      image={CardIssue}
      imageAlt="Payment processing issue"
      headline={"We couldn't process your payment"}
      body={
        "Your most recent payment didn't go through, so your plan is paused for now. Update your info to reactivate."
      }
      actionButtonProps={{
        text: "MANAGE PAYMENT",
        onPress: () =>
          onManagePayment ? onManagePayment() : router.push(Routes.HOME),
        eventData: { action: "payment_err_manage" },
        customEventName: STATSIG_EVENTS.PAYMENT_ERR_MANAGE,
        className: "w-full max-w-sm",
      }}
      className={className}
    />
  );
};

export default PaymentProcessingIssueState;
